import {Button, Modal, Spinner} from 'react-bootstrap'
import {NodeSignatureFormsEntry} from '../../../types/signatureFormsEntriesApi'

interface ModalDeleteSignatureEntryProps {
  entry: NodeSignatureFormsEntry | null
  isOpen: boolean
  loading: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ModalDeleteSignatureEntry: React.FC<ModalDeleteSignatureEntryProps> = ({
  entry,
  isOpen,
  loading,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal show={isOpen} onHide={onClose} centered backdrop='static' keyboard={!loading}>
      <Modal.Header closeButton={!loading}>
        <Modal.Title>Delete Signature Request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='mb-2'>
          Are you sure you want to delete this signature request?
        </p>
        <p className='fw-bold mb-0'>{entry?.signatureForm?.name}</p>
        <small className='text-muted'>
          {entry?.recipient ? `Recipient: ${entry.recipient}` : null}
        </small>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' size='sm' onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant='danger' size='sm' onClick={onConfirm} disabled={loading}>
          {loading && <Spinner animation='border' size='sm' className='me-2' />}
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
